import { useState } from 'react';
import ModalBorrar from '../modals/modalDelete';
import DinamicModal from '../dinamicModal/dinamicModal';
import EntregaForm from './formEntrega';
import Request from "../../core/httpClient";
import moment from 'moment-timezone';
import cogoToast from 'cogo-toast';
import { Consumer } from '../../context';

const request = new Request();

const PaqueteriaTable = (props) => {
	const [loadingSave, setloadingSave] = useState(false);
	const [paquete, setPaquete] = useState({});
	const [id_paquete, setId_Paquete] = useState(0);

	function openModal(idModal, data) {
		setPaquete(data);

		const modal = document.getElementById(idModal);
		if (modal) {
			modal.classList.remove('hide-dinamic-modal');
			modal.classList.add('show-dinamic-modal');
		};
	};

	function closeModal(idModal) {
		setPaquete({});

		const modal = document.getElementById(idModal);
		if (modal) {
			modal.classList.add('hide-dinamic-modal');
			modal.classList.remove('show-dinamic-modal');
		};
	};

	function openModalDelete(paquete) {
		setId_Paquete(paquete.id_paqueteria);

		let modal = document.getElementById("deleteModal");
		if (modal) {
			modal.classList.remove('hide-modal');
			modal.classList.add('show-modal');
		};
	};

	async function handleDelete(id) {
		try {
			const data = { id_paqueteria: id };

			const response = await request.post("/paqueteria/delete", data);

			if (response && !response.error) {
				if (response.deleted && !response.empty) {
					//this.setState({ message: response.message });
					props.reload();
					cogoToast.success('Paquete eliminado.', {
						position: 'bottom-right',
					});
				} else {
					cogoToast.error('No se pudo eliminar el paquete.', {
						position: 'bottom-right',
					});
				}
			} else {
				cogoToast.error('No se pudo eliminar el paquete.', {
					position: 'bottom-right',
				});
			};
		} catch (error) {
			console.log(error);
		};
	};

	async function handleSubmit(event) {

		event.preventDefault();

		try {

			setloadingSave(true);

			const form = event.target;
			const foto_entrega = form.entrega_foto_entrega;

			let file_entrega = null;

			if (foto_entrega.files) {
				file_entrega = foto_entrega.files[0];
			};
			
			// Validación de la imagen de entrega paquete 
			if (!file_entrega) {
			cogoToast.warn('Se debe proporcionar una imagen del paquete.', { position: 'bottom-right' });
			setloadingSave(false);
			return;
			}

			const user = await props.context.loadUser();

			const data = {
				id_paqueteria: paquete.id_paqueteria,
				id_fraccionamiento: localStorage.getItem('frac'),
				id_vivienda: paquete.id_vivienda,
				empresa_paqueteria: paquete.empresa_paqueteria,
				nombre_recibe: form.entrega_nombre_recibe.value,
				fecha_entrega: moment(form.entrega_fecha_entrega.value).format(),
				id_usuario: user.id.id_usuario,
				comentarios: form.entrega_comentarios.value,
			};

			const response = await request.new_postFile('/paqueteria/update', [file_entrega], data);

			if (response.updated) {
				closeModal('modal-edit-paquete');
				props.reload();
				cogoToast.success('Paquete actualizado.', {
					position: 'bottom-right',
				});
			} else {
				cogoToast.error(response.message || 'No se pudo actualizar el paquete.', {
					position: 'bottom-right',
				});
			};

			setloadingSave(false);
		} catch (error) {
			console.log(error);
		};
	};

	return (
		<div className="tw-bg-white tw-shadow tw-rounded-lg tw-p-4 tw-mt-2" id="card-owners">
			<div className="tw-overflow-x-auto tw-max-h-[500px] tw-overflow-y-auto">
				<table className="tw-min-w-full tw-border-collapse">
					<thead id={props.id ? props.id : ''} className="tw-bg-gray-100 tw-sticky tw-top-0">
						<tr className="tw-text-left tw-text-sm tw-font-semibold tw-text-gray-700">
							<th className="tw-px-4 tw-py-2 tw-align-middle">
								<div className="tw-flex tw-items-center tw-gap-1">
									Vivienda &nbsp;
									<div className="tw-flex tw-items-center">
										{props.filterColumn.col === 'numero_registro' ? props.filterColumn.filt === 'asc' ?
											<i className="fas fa-sort-down tw-text-xs" onClick={() => props.sortBy('numero_registro')}></i>
											:
											<i className="fas fa-sort-up tw-text-xs" onClick={() => props.sortBy('numero_registro')}></i>
											:
											<i className="fas fa-sort tw-text-xs" onClick={() => props.sortBy('numero_registro')}></i>
										}
									</div>
								</div>
							</th>
							<th className="tw-px-4 tw-py-2 tw-align-middle">
								<div className="tw-flex tw-items-center tw-gap-1">
									Destinatario &nbsp;
									<div className="tw-flex tw-items-center">
										{props.filterColumn.col === 'nombre_residente' ? props.filterColumn.filt === 'asc' ?
											<i className="fas fa-sort-down tw-text-xs" onClick={() => props.sortBy('nombre_residente')}></i>
											:
											<i className="fas fa-sort-up tw-text-xs" onClick={() => props.sortBy('nombre_residente')}></i>
											:
											<i className="fas fa-sort tw-text-xs" onClick={() => props.sortBy('nombre_residente')}></i>
										}
									</div>
								</div>
							</th>
							<th className="tw-px-4 tw-py-2 tw-align-middle">
								<div className="tw-flex tw-items-center tw-gap-1">
									Fecha Llegada &nbsp;
									<div className="tw-flex tw-items-center">
										{props.filterColumn.col === 'fecha_llegada' ? props.filterColumn.filt === 'asc' ?
											<i className="fas fa-sort-down tw-text-xs" onClick={() => props.sortBy('fecha_llegada')}></i>
											:
											<i className="fas fa-sort-up tw-text-xs" onClick={() => props.sortBy('fecha_llegada')}></i>
											:
											<i className="fas fa-sort tw-text-xs" onClick={() => props.sortBy('fecha_llegada')}></i>
										}
									</div>
								</div>
							</th>
							<th className="tw-px-4 tw-py-2 tw-align-middle">
								<div className="tw-flex tw-items-center tw-gap-1">
									Fecha Entrega &nbsp;
									<div className="tw-flex tw-items-center">
										{props.filterColumn.col === 'fecha_entrega' ? props.filterColumn.filt === 'asc' ?
											<i className="fas fa-sort-down tw-text-xs" onClick={() => props.sortBy('fecha_entrega')}></i>
											:
											<i className="fas fa-sort-up tw-text-xs" onClick={() => props.sortBy('fecha_entrega')}></i>
											:
											<i className="fas fa-sort tw-text-xs" onClick={() => props.sortBy('fecha_entrega')}></i>
										}
									</div>
								</div>
							</th>
							<th className="tw-px-4 tw-py-2 tw-align-middle">Estado</th>
							<th className="tw-px-4 tw-py-2 tw-align-middle tw-text-center">Editar</th>
							<th className="tw-px-4 tw-py-2 tw-align-middle tw-text-center">Borrar</th>
						</tr>
					</thead>
					<tbody className="tw-divide-y tw-divide-gray-200">
						{props.paquetes.slice(((props.page - 1) * props.pageLength), (props.page * props.pageLength)).map((paquete, key) => (
							<tr key={key} className="tw-text-sm">
								<td className="tw-px-4 tw-py-0.2 tw-align-middle">
									{paquete.numero_registro}
								</td>
								<td className="tw-px-4 tw-py-0.2 tw-align-middle">
									{paquete.nombre_residente}
								</td>
								<td className="tw-px-4 tw-py-0.2 tw-align-middle">
									{moment(paquete.fecha_llegada).format('DD/MM/YYYY [-] hh:mm A')}
								</td>
								<td className="tw-px-4 tw-py-0.2 tw-align-middle">
									{paquete.fecha_entrega ? moment(paquete.fecha_entrega).format('DD/MM/YYYY [-] hh:mm A') : null}
								</td>
								<td className="tw-px-4 tw-py-0.2 tw-align-middle">
									{paquete.fecha_entrega ? 'Entregado' : 'Pendiente'}
								</td>
								<td className="tw-px-4 tw-py-0.5 tw-align-middle tw-text-center">
								<button
										type="button justify-center"
										onClick={() => openModal('modal-entrega-paquete', paquete)}
										className="btn-purple tw-inline-flex tw-items-center tw-justify-center tw-w-5 tw-h-5"
									>
										{!paquete.fecha_entrega ? 
										    <i className="font-small fas fa-pen tw-text-xs" />
										:
										    <i className="fas fa-eye tw-text-xs"/>
									}
									</button>
								</td>
								<td className="tw-px-4 tw-py-0.5 tw-text-center tw-align-middle">
									<button
									    type='button'
										onClick={() => openModalDelete(paquete)}
										disabled={!props.escritura || paquete.fecha_entrega}
										className="btn-red tw-inline-flex tw-items-center tw-justify-center tw-place-content-center tw-w-6 tw-h-6"
									>
										<i className="fas fa-trash-alt tw-text-xs" />
									</button>
								</td>
							</tr>
						))}
					</tbody>
				</table>
			</div>
			<DinamicModal
				idModal={'modal-entrega-paquete'}
				sizeModalContainer={'big'}
				title={'Entrega paquete'}
				success={handleSubmit}
				showBtnSuccess={paquete.fecha_entrega ? false : true}
				btnTextSuccess={"GUARDAR"}
				showBtnCancel={paquete.fecha_entrega ? false : true}
				btnTextCancel={"CANCELAR"}
				loadingSave={loadingSave}
				closeModal={closeModal}
			>
				<EntregaForm
					paquete={paquete}
					viviendas={props.viviendas || []} 
				/>
			</DinamicModal>

			<ModalBorrar
				id={id_paquete}
				delete={handleDelete}
			/>
		</div>
	);
};

export default Consumer(PaqueteriaTable);